import React from 'react';
import { Box, Button, Icon, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useHistory } from 'react-router-dom';

interface JamTaskStatusModalProps {
  isCompleted: boolean;
  message?: string;
  onClose: () => void;
  onDismiss: () => void;
  nextTaskUrl?: string;
  'data-testid'?: string;
}

const JamTaskStatusModal: React.FC<JamTaskStatusModalProps> = ({
  isCompleted,
  message,
  onClose,
  onDismiss,
  nextTaskUrl,
  ...rest
}) => {
  const { t } = useTranslation();
  const { modals } = i18nKeys.myJams.challenges.tabs;
  const history = useHistory();

  return (
    <Modal
      data-testid={rest['data-testid']}
      onDismiss={onDismiss}
      visible
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" data-testid="taskCompletedCloseButton" onClick={onClose}>
              {t(i18nKeys.general.close)}
            </Button>
            {isCompleted && nextTaskUrl && (
              <Button
                data-testid="task-completed__next-task"
                onFollow={(e) => {
                  e.preventDefault();
                  onDismiss();
                  history.push(e.detail.href || nextTaskUrl);
                }}
                href={nextTaskUrl}
              >
                {t(modals.completedTask.goToNext)}
              </Button>
            )}
          </SpaceBetween>
        </Box>
      }
      header={isCompleted ? t(modals.completedTask.title) : t(modals.pendingTask.title)}
    >
      {isCompleted ? (
        <SpaceBetween direction="horizontal" size="xs">
          <Box color="text-status-success">
            <Icon name="status-positive" />
          </Box>
          <Box>{message || t(modals.completedTask.body)}</Box>
        </SpaceBetween>
      ) : (
        message || t(modals.pendingTask.body)
      )}
    </Modal>
  );
};

export default JamTaskStatusModal;
